import { render, staticRenderFns } from "./tendency_bar.vue?vue&type=template&id=3429fa6b"
import script from "./tendency_bar.vue?vue&type=script&lang=js"
export * from "./tendency_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports